module.exports = __webpack_public_path__ + "static/media/image.7e3d242b.svg";